import React, { Component } from "react";
import { Route } from "react-router-dom";
import asyncComponent from "helpers/AsyncFunc";
import { USER_ROLE } from "common/enum";

const routes = [
  {
    path: "companies",
    component: asyncComponent(() => import("screen/Company")),
    requieredRole: [USER_ROLE.ADMIN],
  },
  {
    path: "pricing",
    component: asyncComponent(() => import("screen/CatalogItemPrice")),
    requieredRole: [USER_ROLE.ADMIN],
  },
  {
    path: "calcprice",
    component: asyncComponent(() => import("screen/CalcPrice")),
    requieredRole: [USER_ROLE.ADMIN],
  }
];

class AppRouter extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { url, style } = this.props;
    console.log("approle", this.props.role);
    return (
      <div style={style}>
        {routes.map((singleRoute) => {
          if (singleRoute.requieredRole.includes(this.props.role)) {
            const { path, exact, ...otherProps } = singleRoute;
            return (
              <Route
                exact={exact === false ? false : true}
                key={singleRoute.path}
                path={`${url}/${singleRoute.path}`}
                {...otherProps}
              />
            );
          }
        })}
      </div>
    );
  }
}

export default AppRouter;
